// extracted by mini-css-extract-plugin
export default {"watermarkingNotFinished":"n6TmJl0_68zCZfJK2pCI","watermarkingNotFinishedTitle":"RVL6W_ovrforO8ATSqRy","watermarkingNotFinishedDescription":"fSBV9TQSxlQGuSA7fpRC"};